var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, jsxs } from "react/jsx-runtime";
import "../../Utilities.js";
import "../../Styling.js";
import "../Label/index.js";
import { InputValue } from "./InputValue.js";
import { getId } from "@fluentui/utilities";
import { mergeStyles } from "@fluentui/style-utilities";
import { Label } from "../Label/Label.js";
const ReadOnlyField = (props) => {
  const { id = getId(), className, label, value, styles } = props;
  const ariaLabelledBy = !!label && !!value && (!Array.isArray(value) || !!value.length) ? { "aria-labelledby": `${id}-label` } : {};
  const containerClassName = mergeStyles(
    !!label ? {
      minHeight: "26px"
    } : {},
    styles == null ? void 0 : styles.container
  );
  const valueClassName = mergeStyles(
    !label ? {
      lineHeight: "inherit",
      padding: "0"
    } : {},
    styles == null ? void 0 : styles.value
  );
  const _onRenderLabel = (props2) => {
    const { id: id2, className: className2, label: label2 } = props2;
    if (props2.onRenderLabel) {
      return props2.onRenderLabel(props2);
    }
    if (!!label2) {
      return /* @__PURE__ */ jsx(
        Label,
        {
          htmlFor: `${id2}-component`,
          id: `${id2}-label`,
          styles: {
            root: {
              fontWeight: 500
            }
          },
          className: mergeStyles("ms-fontWeight-semibold", className2, styles == null ? void 0 : styles.label),
          children: label2
        }
      );
    }
  };
  return /* @__PURE__ */ jsxs("div", { id, className: mergeStyles(className, styles == null ? void 0 : styles.root), children: [
    _onRenderLabel(__spreadProps(__spreadValues({}, props), {
      id
    })),
    !!value && Array.isArray(value) && !!value.length ? /* @__PURE__ */ jsx(
      "ul",
      {
        id: `${id}-list`,
        className: mergeStyles({
          listStyle: "none",
          padding: 0,
          margin: 0
        }),
        children: value.map((v, index) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(InputValue, __spreadProps(__spreadValues({ id: `${id}-value` }, ariaLabelledBy), { className: valueClassName, value: v })) }))
      }
    ) : /* @__PURE__ */ jsx("div", { className: containerClassName, children: /* @__PURE__ */ jsx(InputValue, __spreadProps(__spreadValues({ id: `${id}-value` }, ariaLabelledBy), { className: valueClassName, value })) })
  ] });
};
export {
  ReadOnlyField,
  ReadOnlyField as default
};
//# sourceMappingURL=ReadOnlyField.js.map
